import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { RContextHelperenwj28riclsp as RContextHelper } from './RContext.mjs';
import { DynamicCssr3610hzbsxx2 as DynamicCss } from './DynamicCss.js.mjs';
import { KiteUiCsshhimfofutzw8 as KiteUiCss } from './KiteUiCss.mjs';
import { Default_getInstance3u4i6y54ri5cn as Default_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/random/Random.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var RContextClass;
function RContext() {
  if (RContextClass === VOID) {
    class $ extends RContextHelper() {
      constructor(basePath, dynamicCss, kiteUiCss) {
        dynamicCss = dynamicCss === VOID ? new (DynamicCss())(basePath) : dynamicCss;
        kiteUiCss = kiteUiCss === VOID ? new (KiteUiCss())(dynamicCss) : kiteUiCss;
        super();
        this.ob3_1 = basePath;
        this.pb3_1 = dynamicCss;
        this.qb3_1 = kiteUiCss;
        this.rb3_1 = Default_getInstance().ul();
        this.sb3_1 = false;
      }
      tb3() {
        // Inline function 'kotlin.apply' call
        var this_0 = new (RContext())(this.ob3_1, this.pb3_1, this.qb3_1);
        this_0.ub3_1.u3(this.ub3_1);
        return this_0;
      }
      toString() {
        return 'RContext@' + this.rb3_1;
      }
    }
    initMetadataForClass($, 'RContext');
    RContextClass = $;
  }
  return RContextClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  RContext as RContext22p6sq97lnq6o,
};
//endregion

//# sourceMappingURL=RContext.commonHtml.mjs.map
